import { getRequest } from 'config/Axios/baseConfig';
import { HourlyScheduleByRoomResponse } from 'screens/CalculationsScreen/components/HourlyScheduleByRoomTable/hourlyScheduleByRoom.types';

export const hourlyScheduleByRoomService = {
  getHourlyScheduleByRoom: async (date: string): Promise<HourlyScheduleByRoomResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getRequest<HourlyScheduleByRoomResponse>(
          `pps/calculations/hourly-schedule-by-rooms/${date}`
        );
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
